import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import RadioButton from '../../ui/buttons/RadioButton';
import '../../styles/components/prompt-builder/PlatformSelector.scss';

interface PlatformSelectorProps {
  selectedPlatforms: string[];
  onChange: (platforms: string[]) => void;
}

const PLATFORMS = [
  {
    id: 'shopify',
    name: 'Shopify',
    icon: '🛍️',
  },
  {
    id: 'stripe',
    name: 'Stripe',
    icon: '💳',
  },
  {
    id: 'intercom',
    name: 'Intercom',
    icon: '💬',
  },
  {
    id: 'hubspot',
    name: 'Hubspot',
    icon: '📈',
  },
  {
    id: 'woocommerce',
    name: 'WooCommerce',
    icon: '🛒',
  },
  {
    id: 'google_analytics',
    name: 'Google Analytics',
    icon: '📊',
  },
  {
    id: 'google_ads',
    name: 'Google Ads',
    icon: '🔍',
  },
  {
    id: 'google_search_console',
    name: 'Google Search Console',
    icon: '🔎',
  },
  {
    id: 'facebook_ads',
    name: 'Facebook Ads',
    icon: '👍',
  },
  {
    id: 'tiktok_ads',
    name: 'TikTok Ads',
    icon: '🎵',
  },
  {
    id: 'linkedin_ads',
    name: 'LinkedIn Ads',
    icon: '💼',
  },
];

export const PlatformSelector: React.FC<PlatformSelectorProps> = ({
  selectedPlatforms,
  onChange,
}) => {
  const handlePlatformChange = (platformId: string) => {
    if (selectedPlatforms.includes(platformId)) {
      onChange(selectedPlatforms.filter((p) => p !== platformId));
    } else {
      onChange([...selectedPlatforms, platformId]);
    }
  };

  const isDarkMode = useSelector((state: RootState) => state.UI.theme.dark);

  return (
    <div className='platform-selector'>
      {PLATFORMS.map((platform) => {
        const isSelected = selectedPlatforms.includes(platform.id);
        return (
          <div
            key={platform.id}
            className={`platform-selector__item ${
              isSelected ? 'selected' : ''
            }`}
            style={
              isDarkMode
                ? {
                    backgroundColor: isSelected ? '#f59e0b' : '#374151',
                    borderColor: isSelected ? '#f59e0b' : '#4b5563',
                    color: isSelected ? '#000' : '#e5e7eb',
                  }
                : undefined
            }
            onClick={() => handlePlatformChange(platform.id)}
          >
            <RadioButton
              label=''
              name={`platform-${platform.id}`}
              value={platform.id}
              checked={isSelected}
              onChange={() => handlePlatformChange(platform.id)}
            />
            <div className='platform-selector__item-info'>
              <span
                className='platform-selector__item-icon'
                aria-hidden='true'
                style={
                  isDarkMode
                    ? { color: isSelected ? '#000' : '#e5e7eb' }
                    : undefined
                }
              >
                {platform.icon}
              </span>
              <span
                className='platform-selector__item-name'
                style={
                  isDarkMode
                    ? { color: isSelected ? '#000' : '#e5e7eb' }
                    : undefined
                }
              >
                {platform.name}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};
